'use client';

import Box from '../../../atoms/Box/Box';
import Typography from '../../../atoms/Typography/Typography';
import type { ContentField } from '../types';
import styles from '../Form.module.scss';

export type ContentControlProps = {
  field: ContentField;
  theme?: 'dark' | 'light';
  direction?: 'ltr' | 'rtl';
};

/**
 * Form control for content/typography display
 * @component
 * @param {ContentControlProps} props - Component props
 * @returns {JSX.Element} Content control component
 */
const ContentControl = ({ field, theme = 'dark', direction = 'ltr' }: ContentControlProps) => {
  return (
    <Box pb={12} className={styles.contentWrapper} key={`form_field_${field.id}`}>
      {field.label && (
        <Typography
          variant="label"
          size="small"
          direction={direction}
          theme={field.theme ?? theme}
          color="gray-3"
        >
          {field.label}
        </Typography>
      )}
      <Box mt={field.label ? 8 : 0}>
        <Typography
          variant={field?.variant}
          color={field?.color}
          align={field?.align}
          size={field?.size}
          theme={field?.theme ?? theme}
        >
          {field.content}
        </Typography>
      </Box>
    </Box>
  );
};

export default ContentControl;
